export default __webpack_public_path__ + "0c510afd6169a0a83f97fa434422d3e9.svg";